import {
  CheckLendCollectionListRequestCollection,
  CheckLendCollectionListRequestCollectionToJSON
} from '@/api'

export interface GetLendCollectionListRequest {
  id: number
  collectionNo: string
  userId: string
  dueDate: string
  handlingType: string
  shelfType: string
  _deleteHandlingType: boolean
  isReading: boolean
  collections: CheckLendCollectionListRequestCollection[]
}

export function GetLendCollectionListRequestToJSON(
  value: GetLendCollectionListRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    user_id: value.userId !== '' ? value.userId : undefined,
    due_date: value.dueDate !== '' ? value.dueDate : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    _delete_handling_type: value._deleteHandlingType ?? undefined,
    is_reading: value.isReading ?? undefined,
    collections:
      value.collections.length > 0
        ? value.collections.map(CheckLendCollectionListRequestCollectionToJSON)
        : undefined
  }
}
